import type { DocumentsSortField } from '@/features/documents/DocumentStore'
import type { Direction } from '@/infra/paging'

/**
 * How a column is sorted, `none` when it isn't.
 */
export type ColumnSortOrder = Direction | 'none'

/**
 * Unique identifiers for each column.
 */
export type ColumnId =
  | 'Checkbox'
  | 'DocumentTitle'
  | 'Workspace'
  | 'Type'
  | 'DateModified'
  | 'LinkedJob'
  | 'Action'

export interface StaticColumnDetails {
  id: ColumnId
  header: string
  sortable: boolean
  field?: DocumentsSortField
}

/**
 * Static column details for populating the Document Management table.
 */
export const DocumentsTableColumns: StaticColumnDetails[] = [
  {
    id: 'Checkbox',
    header: '',
    sortable: false,
  },
  {
    id: 'DocumentTitle',
    header: 'Name',
    sortable: true,
    field: 'Title',
  },
  {
    id: 'Workspace',
    header: 'Workspace',
    sortable: false,
  },
  {
    id: 'Type',
    header: 'Type',
    sortable: false,
  },
  {
    id: 'DateModified',
    header: 'Modified',
    sortable: true,
    field: 'DateModified',
  },
  {
    id: 'LinkedJob',
    header: 'Linked to',
    sortable: false,
  },
  {
    id: 'Action',
    header: '',
    sortable: false,
  },
]
